import { useMemo, useState } from "react"

import { MESSAGE_MODALS } from "../../../../context/custom/MessageModalContext"
import { OPERATION_MODE } from '@laramie/ui';
import AddModal from "./components/AddModal"
import {TIPS} from "../../../../consts/tips";

import { Accordion, FormError, FormLabel, InputLista, Modal, TableCustom } from "../../../../components/common"
import { useFormErrors, useManagedContext } from "../../../../components/hooks"
import { VALIDATION_MESSAGE } from "../../../../consts/validationMessage"

const Variables = ({ params, data, setData, colecciones, coleccionesCampo, setPendingChange }) => {
    const { showMessageModal } = useManagedContext()

    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()

    const coleccionCampoCells = useMemo(() => {
        const result = {}
        coleccionesCampo.forEach(campo => {
            const coleccion = colecciones.find(x => x.id === campo.idColeccion)
            result[campo.id] = `${coleccion.nombre} / ${campo.nombre}`
        })
        return result
    }, [colecciones, coleccionesCampo])

    //#region events
    const onAdd = (item) => {
        setEditMode('add')
    }

    const onView = (item) => {
        setEditItem(item)
        setEditMode('view')
    }

    const onModify = (item) => {
        setEditItem({ ...item, state: item.state === 'a' ? 'a' : 'm', })
        setEditMode('modify')
    }

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}
        if (!editItem) return errors

        if (editItem.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (editItem.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED

        return errors
    }

    const onModalExit = () => {
        setEditItem(null)
        setEditMode(null)
        reset()
    }

    const onModalConfirm = () => {
        if (!validate()) return

        if (editMode === 'modify') {
            setData(data.map(x => x.id === editItem.id ? editItem : x))
        }
        if (editMode === 'add') {
            setData([...data, editItem])
        }

        setPendingChange(true)
        onModalExit()
    }

    const onColeccionesSelected = (items) => {
        setData([...data, ...items.map((item, index) => ({
            id: -Date.now() + index,
            idProcedimiento: parseInt(params.id),
            idColeccionCampo: item.id,
            idTipoVariable: item.idTipoVariable,
            codigo: item.codigo,
            nombre: item.nombre,
            tipoDato: item.tipoDato,
            orden: data.length + index + 1,
            state: 'a',
        }))])
        setEditMode(null)

        if (items.length > 0)
            setPendingChange(true)
    }

    const onClickRemove = (item) => {
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Está seguro de borrar la variable ${item.nombre}?`,
            onConfirm: () => {
                if (item.state === 'a') setData(data.filter(x => x.id !== item.id))
                else setData(data.map(x => x.id !== item.id ? x : {...x, state: 'r'}))
                setPendingChange(true)
            }
        })
    }
    //#endregion

    const filteredData = useMemo(() => {
        return data.filter(x => x.state !== 'r')
    }, [data])

    const cellAVMR = {
        id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
        Header: (props) => (
            <div className='action'>
                {params.mode !== OPERATION_MODE.VIEW && (
                    <div onClick={onAdd} className="link">
                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                    </div>
                )}
            </div>
        ),
        Cell: (props) =>  (
            <div className='action'>
                <div onClick={() => onView(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Ver">search</span>
                </div>
                {params.mode !== OPERATION_MODE.VIEW && <>
                    <div onClick={() => onModify(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Modificar">stylus</span>
                    </div>
                    <div onClick={() => onClickRemove(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Eliminar">delete</span>
                    </div>
                </>}
            </div>
        ),
    }

    return <>
        <Accordion title="Variables" className="m-top-20">
            <div className='row form-basic'>
                <TableCustom
                    className={'TableCustomBase'}
                    data={filteredData}
                    columns={[
                        {
                            Header: 'Colección / Campo',
                            accessor: 'idColeccionCampo',
                            Cell: ({ value }) => coleccionCampoCells[value]??value,
                            width: '30%',
                        },
                        { Header: 'Código', accessor: 'codigo', width: '30%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '30%', },
                        cellAVMR,
                    ]}
                />
            </div>
        </Accordion>

        {['view', 'modify'].includes(editMode) && (
            <Modal
                onEscape={onModalExit}
                show={true}
                title='Variable'
                tipName={TIPS.NAME.MODALS.PARAMETRO_MODAL}
                header={<div/>}
                body={(
                    <Accordion title="Datos de la variable" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-6 col-xl-3">
                                <FormLabel htmlFor="nombre" required>Código</FormLabel>
                                <input
                                    name="nombre"
                                    type="text"
                                    placeholder=""
                                    className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                    value={editItem.codigo}
                                    onChange={({ target }) => {
                                        if (!/[^a-zA-Z0-9_]/g.test(target.value))
                                            setEditItem(prev => ({...prev, codigo: target.value}))
                                    }}
                                    disabled={editMode === 'view'}
                                />
                                <FormError message={errorOf('codigo')} />
                            </div>
                            <div className="col-12 col-md-6 col-xl-4">
                                <FormLabel htmlFor="descripcion" required>Nombre</FormLabel>
                                <input
                                    name="descripcion"
                                    type="text"
                                    placeholder=""
                                    className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                    value={editItem.nombre}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, nombre: target.value}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError message={errorOf('nombre')} />
                            </div>
                            <div className="col-12 col-md-6 col-xl-3">
                                <label htmlFor="idTipoVariable" className="form-label">Tipo de variable</label>
                                <InputLista
                                    name="idTipoVariable"
                                    placeholder=""
                                    className="form-control"
                                    value={editItem.idTipoVariable}
                                    lista="TipoVariable"
                                    disabled
                                />
                                <FormError />
                            </div>
                            <div className="col-12 col-md-6 col-xl-2">
                                <label htmlFor="tipoDato" className="form-label">Tipo de dato</label>
                                <input
                                    name="descripcion"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    value={editItem.tipoDato}
                                    disabled
                                />
                                <FormError />
                            </div>
                            <div className="col-12 col-md-6 col-xl-10">
                                <label htmlFor="idEstadoProcedimiento" className="form-label">Colección/Campo</label>
                                <input
                                    name="idColeccionCampo"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    value={coleccionCampoCells[editItem.idColeccionCampo]}
                                    disabled
                                />
                                <FormError />
                            </div>
                            <div className="col-12 col-md-6 col-xl-2">
                                <label htmlFor="idEstadoProcedimiento" className="form-label">Orden</label>
                                <input
                                    name="orden"
                                    type="number"
                                    placeholder=""
                                    className="form-control"
                                    value={editItem.orden}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, orden: parseInt(target.value)}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError />
                            </div>
                        </div>
                    </Accordion>
                )}
                footer={<>
                    {editMode !== 'view' && <>
                        <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onModalExit}>Cancelar</button>
                        <button className="btn btn-primary" data-dismiss="modal"  onClick={onModalConfirm}>Aceptar</button>
                    </>}
                    {editMode == 'view' && 
                    <div className="width-100p f-align">
                        <button className="btn back-button" data-dismiss="modal" onClick={onModalExit}>Volver</button>
                    </div>} 

                </>}
            />
        )}

        {editMode === 'add' && <AddModal
            colecciones={colecciones}
            tableData={filteredData}
            show={editMode === 'add'}
            onCancel={() => setEditMode(null)}
            onAccept={onColeccionesSelected}
        />}
    </>
}

export default Variables
